import {
  arrayOf,
  boolOf,
  fail,
  idOf,
  numberOf,
  objectOf,
  optionalBool,
  optionalNumber,
  optionalText,
  textOf,
} from '../../../shared/api/wire'
import type { AqsiGoodCard, AqsiGoodEditResult } from '../model/types'

/** Карточка кабинета живьём (`GET …/card`): без конверта, как ответы цен. Цена приходит числом кабинета. */
export function decodeGoodCard(raw: unknown): AqsiGoodCard {
  const data = objectOf(raw, 'карточка товара')
  const price = data.price
  const properties = data.customProperties
  return {
    goodId: idOf(data.goodId, 'goodId'),
    name: textOf(data.name, 'name'),
    sku: optionalText(data.sku, 'sku'),
    groupId: optionalText(data.groupId, 'groupId'),
    price: price === null || price === undefined ? null : numberOf(price, 'price'),
    barcodes: arrayOf(data.barcodes ?? [], 'barcodes').map((item, index) => textOf(item, `barcodes[${index}]`)),
    tax: optionalNumber(data.tax, 'tax'),
    subject: optionalNumber(data.subject, 'subject'),
    unit: optionalText(data.unit, 'unit'),
    unitCode: optionalNumber(data.unitCode, 'unitCode'),
    paymentMethodType: optionalNumber(data.paymentMethodType, 'paymentMethodType'),
    type: optionalText(data.type, 'type'),
    isWeight: optionalBool(data.isWeight, 'isWeight'),
    customProperties:
      properties === null || properties === undefined
        ? null
        : arrayOf(properties, 'customProperties').map((item, index) => {
            const property = objectOf(item, `customProperties[${index}]`)
            return { key: textOf(property.key, `customProperties[${index}].key`), value: textOf(property.value, `customProperties[${index}].value`) }
          }),
    ownedPropertyKeys: arrayOf(data.ownedPropertyKeys ?? [], 'ownedPropertyKeys').map((item, index) => textOf(item, `ownedPropertyKeys[${index}]`)),
    shops: arrayOf(data.shops ?? [], 'shops').map((item, index) => {
      const shop = objectOf(item, `shops[${index}]`)
      return {
        shopId: textOf(shop.shopId, `shops[${index}].shopId`),
        name: optionalText(shop.name, `shops[${index}].name`),
        resourceShop: boolOf(shop.resourceShop, `shops[${index}].resourceShop`),
      }
    }),
    resourceShopId: textOf(data.resourceShopId, 'resourceShopId'),
    updatedAt: optionalText(data.updatedAt, 'updatedAt'),
  }
}

/** Итог правки: `applied` — кабинет принял, чтение подтвердило; `unchanged` — там уже стояли эти значения. */
export function decodeGoodEdit(raw: unknown): AqsiGoodEditResult {
  const data = objectOf(raw, 'итог правки товара')
  const outcome = textOf(data.outcome, 'outcome')
  if (outcome !== 'applied' && outcome !== 'unchanged') return fail(`outcome — неизвестное значение «${outcome}»`)
  return { outcome, card: decodeGoodCard(data.card), snapshotUpdated: boolOf(data.snapshotUpdated, 'snapshotUpdated') }
}
